<!--
 * @Description:
 * @Author: black-k
 * @Date: 2024-08-30 10:21:44
 * @LastEditors: black-k
 * @LastEditTime: 2025-10-09 12:59:13
-->
<template>
    <div class="business-analysis">
        <div class="box_header">
            <DataCenterHeader @selectAccountData="getAccountInfo">
                <!-- <el-button slot="header-right" size="mini" @click="handlePublish">发布作品</el-button> -->
            </DataCenterHeader>
        </div>

        <div class="content-box">
            <div class="menus">
                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                    <el-menu-item v-for="item in menuConfig" :key="item.index" :index="item.index">{{ item.name }}</el-menu-item>
                </el-menu>
            </div>

            <component ref="componentRef" :is="getComponents" :account="accountInfo" :is-header="false"></component>
        </div>
    </div>
</template>

<script>
import DataCenterHeader from "@/components/dataCenter/DataCenterHeader.vue";
import ShortVideo from "@/components/dataCenter/ShortVideo.vue";
import LiveStreaming from "@/components/dataCenter/LiveStreaming.vue";
import VideoManagementNew from "../VideoManagementNew.vue";
import FanPortrait from "./FanPortrait.vue";

export default {
    data() {
        return {
            accountInfo: {},
            activeIndex: "1",
            menuConfig: [
                {
                    index: "1",
                    name: "短视频",
                    component: "ShortVideo",
                },
                {
                    index: "2",
                    name: "直播",
                    component: "LiveStreaming",
                },
                // {
                //     index: "3",
                //     name: "粉丝画像",
                //     component: "FanPortrait",
                // },
                // {
                //     index: "4",
                //     name: "作品管理",
                //     component: "VideoManagementNew",
                // },
            ],
        };
    },
    computed: {
        getComponents() {
            const component = this.menuConfig.find((item) => item.index == this.activeIndex);
            return component.component;
        },
    },
    components: {
        DataCenterHeader,
        ShortVideo,
        LiveStreaming,
        VideoManagementNew,
        FanPortrait,
    },
    methods: {
        getInitData() {
            if (this.activeIndex === "3") {
                this.$refs.componentRef?.getFans(this.accountInfo);
            } else if (this.activeIndex === "4") {
                this.$refs.componentRef?.getAccountInfo(this.accountInfo);
            }
        },

        getAccountInfo(accountInfo) {
            this.accountInfo = accountInfo;

            this.getInitData();
        },

        // 发布作品
        handlePublish() {
            console.log("发布作品");
        },

        handleSelect(key, keyPath) {
            this.activeIndex = key;

            this.$nextTick(() => {
                this.getInitData();
            });
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-button {
    border: none;
    background-color: #594fee;
    color: #fff;
}
.business-analysis {
    .box-header {
    }

    .content-box {
        background-color: #fff;
        min-height: calc(100vh - 235px);
        margin-top: 20px;
        padding: 0 24px 24px 24px;
        border-radius: 8px;
        box-sizing: border-box;

        ::v-deep .el-menu--horizontal > .el-menu-item.is-active {
            border-color: #594fee;
        }
    }
}
</style>
